import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"checkmark\">\n  <path d=\"M5 45a40 40 0 1 0 80 0 40 40 0 0 0-80 0Z\" />\n  <path stroke=\"white\" stroke-width=\"4\" d=\"m26 48 14 12 24-30\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol